import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
const STEP = [{
  n: '1',
  t: 'You type',
  d: 'The palette shows navigation and actions immediately from a local list, so the first paint never waits on the network.'
}, {
  n: '2',
  t: 'Scoped query',
  d: 'After a short debounce the query goes to the proxy, which derives your company from the verified token. Company is the partition key, not a filter.'
}, {
  n: '3',
  t: 'Index first',
  d: 'A denormalised index answers in one partitioned query. A query cannot return another company’s rows even if the terms match them.'
}, {
  n: '4',
  t: 'Live fallback',
  d: 'On a miss the same scoped service APIs the assistant uses answer directly, so a cold partition degrades to slower rather than empty.'
}, {
  n: '5',
  t: 'Knowledge base',
  d: 'Articles are searched alongside records and filtered by audience, so an internal article never appears for someone who may not read it.'
}];
export function SearchTab() {
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      pt: '16px',
      maxWidth: 780
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    sx: {
      fontSize: 18,
      fontWeight: 600,
      mb: '4px'
    }
  }, "Universal search architecture"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "text.secondary",
    sx: {
      mb: '20px'
    }
  }, "One keystroke surface over navigation, records and the knowledge base. Cmd-K anywhere in the app, or the Search item in the sidebar."), /*#__PURE__*/React.createElement(Stack, {
    spacing: "10px",
    sx: {
      mb: '26px'
    }
  }, STEP.map(s => /*#__PURE__*/React.createElement(Stack, {
    key: s.n,
    direction: "row",
    spacing: "12px",
    sx: {
      border: 1,
      borderColor: 'divider',
      borderRadius: '10px',
      p: '13px'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      width: 24,
      height: 24,
      flex: '0 0 auto',
      borderRadius: '7px',
      display: 'grid',
      placeItems: 'center',
      bgcolor: 'primary.main',
      color: 'primary.contrastText',
      fontSize: 12,
      fontWeight: 700
    }
  }, s.n), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Typography, {
    sx: {
      fontSize: 13.5,
      fontWeight: 600
    }
  }, s.t), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "text.secondary",
    sx: {
      fontSize: 13
    }
  }, s.d))))), /*#__PURE__*/React.createElement(Typography, {
    sx: {
      fontSize: 13,
      fontWeight: 600,
      mb: '6px'
    }
  }, "Why an index and not just live lookups"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "text.secondary",
    sx: {
      mb: '18px'
    }
  }, "The assistant can already reach every service through its tools, and search reuses that reach. What it cannot do is fan out across several services on every keystroke, so the keystroke path reads a denormalised index instead and reconciles against those same services in the background. An index without reconciliation drifts silently, and a silently stale index is worse than no index."), /*#__PURE__*/React.createElement(Typography, {
    sx: {
      fontSize: 13,
      fontWeight: 600,
      mb: '6px'
    }
  }, "What is indexed"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "text.secondary"
  }, "Properties, units, residents and companies, plus knowledge base articles. Each row stores the destination it should open, resolved when the row is written rather than guessed at click time, so a result can never be a dead link."));
}